import React from 'react'

export const ButtonCircle = ({item,onClick}) => {
  return (
    <button className='flex flex-col justify-center items-center gap-2 xl:gap-4 '  onClick={onClick} >
        <img src={item.image} alt='' className='rounded-full border-[4px] border-[--color-button-1] hover:border-gray-300 transition-all duration-150' />

        <span className='font-bold hover:text-[--color-button-3] transition-all duration-150 text-xs xl:text-base'>{item.label}</span>
    </button>
  )
}
